const uk = {
  100000001:'Ключова інформація',
  100000002:'Назва токена',
  100000003:'Створювач копії',
  100000004:'Час створення екземпляра',
  100000005:'Основна інформація',
  100000006:'Відповідний блокчейн/протокол  ',
  100000007:'Адреса смарт-контракту  ',
  100000008:'Дата випуску',
  100000009:'Всього постачання',
  100000010:'Циркуляційне Постачання',
  100000011:'Ринкова вартість',
  100000012:'інфо',
  100000013:'Інформація в соціальних мережах',
  100000014:'Веб-сайт',
  100000015:'White Paper',
  100000016:'Браузер блокчейну  ',
  100000017:'Оцінка проекту',
  100000018:'Рейтинг',
  100000019:'Топ',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Час оновлення',
  100000027:'Оцінка безпеки  ',
  100000028:'Оцінка безпеки контракту  ',
  100000029:'Статистика ризикових проєктів  ',
  100000030:'Деталі коду контракту  ',
  100000031:'Податок на покупку  ',
  100000032:'Податок на продаж  ',
  100000033:'Це міскод  ',
  100000034:'Можна знову mint  ',
  100000035:'Існує чорний список  ',
  100000036:'Існує білий список  ',
  100000037:'Є анти-кит  ',
  100000038:'Можна змінити податкову ставку  ',
  100000039:'Є відкритим кодом  ',
  100000040:'Є приховані власники  ',
  100000041:'Можна знищити себе  ',
  100000042:'Є проксі-контрактом  ',
  100000043:'Можна змінити баланс  ',
  100000044:'Можна виконувати зовнішні виклики  ',
  100000045:'Можна відновити право власності  ',
  100000046:'Є період спокою для транзакцій  ',
  100000047:'Можна призупинити перекази  ',
  100000048:'Право власності не відмовлено  ',
  100000049:'Є регульованим анти-китом  ',
  100000050:'Занадто багато десяткових знаків  ',
  100000051:'Публічні методи Mint і Burn  ',
  100000052:'Спалення токенів оновлює загальну кількість  ',
  100000053:'Спалення токенів оновлює баланс  ',
  100000054:'Переказ самому собі збільшує баланс  ',
  100000055:'Транзакція на суму',
  100000056:'Баланс не оновлено під час переказу  ',
  100000057:'Баланс одержувача буде витрачено  ',
  100000058:'Виклик TransferFrom при перевищенні балансу призводить до помилки  ',
  100000059:'Метод BurnFrom оновлює загальну кількість  ',
  100000060:'Визначте податок на купівлю токена. Понад 5% вважається високою податковою ставкою',
  100000061:'Визначте податок на продаж токена. Понад 5% вважається високою податковою ставкою',
  100000062:'Перевірте, чи є токен шахрайською схемою типу honeypot',
  100000063:'Перевірте, чи можна створити більше токенів',
  100000064:'Перевірте, чи має токен чорний список, який може обмежувати користувачів у обміні або передачі токенів',
  100000065:'Перевірте, чи має токен білий список, що дозволяє адресам обходити будь-які обмеження',
  100000066:'Перевірте, чи має токен механізми проти великих власників (анти-кит)',
  100000067:'Перевірте, чи є у токена податок і чи може цей податок бути змінений привілейованими ролями',
  100000068:'Перевірте, чи був токен перевірений у блокчейн-експлорері',
  100000069:'Перевірте, чи є у токена прихований власник, який може маніпулювати контрактом, навіть якщо здається, що права власності були відхилені',
  100000070:'Перевірте, чи може токен самознищитися',
  100000071:'Перевірте, чи є токен проксі-контрактом, який делегує виклики функцій контракту реалізації',
  100000072:'Перевірте, чи може баланс токена бути змінений привілейованими ролями',
  100000073:'Перевірте, чи викликає токен зовнішні контракти',
  100000074:'Перевірте, чи має токен лазівку для відновлення прав власності',
  100000075:'Перевірте, чи має токен механізм затримки при передачі',
  100000076:'Перевірте, чи може торгівля токеном бути призупинена привілейованими ролями',
  100000077:'Перевірте, чи були права власника відхилені',
  100000078:'Перевірте, чи можуть механізми проти великих власників бути змінені привілейованими ролями',
  100000079:'Перевірте, чи є значення, що повертається функцією decimals(), більше або дорівнює 5',
  100000080:'Перевірте, чи призведе виклик функцій mint() та burn() випадковими користувачами до відхилення',
  100000081:'Перевірте, чи правильно оновлюється totalSupply при виклику функції burn()',
  100000082:"Перевірте, чи правильно оновлюється дозволене значення при виклику функції burnFrom()",
  100000083:'Перевірте, чи збільшиться баланс відправника при виклику функції transfer(), якщо отримувач такий самий, як і відправник транзакції',
  100000084:'Перевірте, чи зазнає невдачі виклик функції transfer() з кількістю, що перевищує баланс',
  100000085:"Перевірте, чи оновлюється відповідно дозволене значення для витрачаючого після виклику функції transferFrom()",
  100000086:"Перевірте, чи використовує виклик функції transferFrom() баланс витрачаючого",
  100000087:"Перевірте, чи правильно оновлюється дозволена сума після виклику transferFrom(), або чи відміняється транзакція, якщо сума недійсна.",
  100000088:"Перевірте, чи правильно оновлюється totalSupply при виклику функції burnFrom()",
  100000089:'Перевірте, чи існує право на створення токенів',
  100000090:'Перевірте, чи існує право на заморожування',
  100000091:'Перевірте, чи можна змінити метадані',
  100000092:'Критичний',
  100000093:'Важливий',
  100000094:'Середній',
  100000095:'Незначний',
  100000096:'Інформаційний',
  100000097:'Відмовлено від дозволу на mint  ',
  100000098:'Відмовлено від дозволу на замороження  ',
  100000099:'Можна змінити метадані токена  ',

  100000100:'Ваш річний звіт генерується…',
  100000101:'Ласкаво просимо',
  100000102:'Ваш огляд 2024 року',
  100000103:'Я ваш персональний гід.',
  100000104:'Давайте згадаємо про те, що ми пройшли в 2024 році.',
  100000105:'Відкрити звіт',
  100000106:'{num} днів тому, колеса долі почали обертатись',
  100000107:'{userName} Наша історія починається звідси',
  100000108:'Для нашої спільної мрії ми біжимо разом',
  100000109:'Зірка інвестиційного прибутку',
  100000110:'Щорічний огляд гаманця накопиченого доходу',
  100000111:'Ви випереджаєте <em class="normal bold" style="color: #2AFF0A;">{percentage}</em>користувачів',
  100000112:'Протягом минулого року ми пережили <em class="normal bold" style="color: #FFF;">FOMO</em>, що принесло написання, і насолоджувалися радістю від <em class="normal bold" style="color: #FFF;">meme зростання</em>. Тепер давайте разом поринемо у ваші спогади.',
  100000113:'Торговець-ас',
  100000114:'Накопичений торгівлі за 2024 рік (раз)',
  100000115:'Сумарна сума угод ($)',
  100000116:'Ви перевищили <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> користувачів.',
  100000117:'Це не тільки накопичення чисел, а й ваш медаль за бачення та мудрість.',
  100000118:'Кожна угода - це крок до Web3.0.',
  100000119:'Потенційна зірка',
  100000120:'Максимальне падіння біткоїна у 2024 році склало <em class="normal">34%</em>, ринкові корекції стали нормою. Ваші інвестиційні результати - це лише тимчасовий результат, а майбутнє все ще сповнене можливостей!',
  100000121:'Сталий інвестор',
  100000122:'Кожне спостереження і очікування — це шлях до більш точного моменту. Сподіваємося, що в 2025 році ви побачите чудо своїх інвестицій і прибутків.',
  100000123:'Токен, який ви торгували найбільше у 2024 році.',
  100000124:'Якщо не забути, обов\'язково буде відповідь',
  100000125:'Фокус і зусилля сяють у результатах торгівлі.',
  100000126:'Зміна біткоїнів на SuperEx у 2024 році',
  100000127:'У вашій Bitcoin волатильності у 2024 році',
  100000128:'Вітаємо! Ваші активи зросли! У наступному році продовжуйте в тому ж дусі.',
  100000129:'У 2024 році ви ще не володіли Біткоїном.',
  100000130:'Видатний інвестор',
  100000131:'Сталий інвестор',
  100000132:'Навчаючийся інвестор',
  100000133:'Ваші дані про торгівлю спотовою основною платою',
  100000134:'доход($)',
  100000135:'Річна дохідність (%)',
  100000136:'Прибуток Лідер (%)',
  100000137:'Ваші дані про контрактну торгівлю',
  100000138:'Ви продемонстрували мудрість у вашій інвестиційній стратегії. Дякуємо, що обрали йти з нами!',
  100000139:'Підняти вітрила·Знову в плавання',
  100000140:'Ви не тільки йдете в ногу з модою, ви ще й її піонер! Ви запустили монети у вільній зоні <em class="normal bold" style="color: #FFF;">{num1}</em> разів і провели <em class="normal bold" style="color: #FFF;">{num2}</em> угод. Ви, хто любить інноваційні продукти, - справжній авантюрист!',
  100000141:'Супер соціальний вплив',
  100000142:'Дякуємо, що принесли нам <em class="normal bold" style="color: #FFF;">{num}</em> нових облич. Платформа процвітає завдяки вашим рекомендаціям, і сподіваємося, що на шляху до Web3.0 у нас буде більше однодумців.',
  100000143:'Соціальний потенціал нова зірка',
  100000144:'У SuperEx є <em class="normal bold" style="color: #FFF;">{num}</em> користувач, які заробляють до 40% комісії за торгівлю, запрошуючи друзів. Ви пропустили 2024 рік, але нічого страшного. У 2025 році скористайтеся можливістю.',
  100000145:'Обміняйте свої яскраві моменти року! Поділіться з вашим співтовариством, щоб заохотити більше людей приєднатися до нас, розблокувати ексклюзивні винагороди разом і досліджувати світ криптовалюти!',
  100000146:'Запросіть друга, щоб отримати винагороду вартістю 10 USDT!',
  100000147:'Поділитися звітом',
  100000148:'Перегляд знову',
  100000149:'В 2024 році вас називають на Superex.',
  100000150:'Ви перевищили користувачів платформи:',
  100000151:'Основний ринок Спотова торгівля Річна дохідність',
  100000152:'Контракт Річна дохідність',
  100000153:'Цього року я легенда інвестицій!',
  100000154:'Запрошений код: {InviteCode}',
  100000155:'SuperEx.com - Web3.0 криптовалютна біржа',
  100000156:'Шукай перемогу в стабільності, демонструй свою силу!',
  100000157:'Цього року накопичили досвід, наступний рік буде ще яскравішим!',
  100000158:'Ти знаєш?',
  100000159:'Свобода спотовой торговли SuperEx - это самая популярная и перспективная платформа для торговли Meme-криптовалютами в мире.',
  100000160:'2024, SuperEx додає <em class="normal bold" style="color: #FFF;">{num}</em> користувачів, як нову родину',
  100000161:'Ваш огляд 2024 року та подорож до тисячократного прибутку у 2025 році незабаром розпочнуться.',
  100000162:'Це лист від досвідченого члена родини Superex, в якому зафіксовано їхні гарні новини на 2024 рік.',
  100000163:'@to*** успішно купив 1 BTC за 1 USDT, прибутковість складає <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>.',
  100000164:'@1o*** отримав 1 ETH за 1 USDT, дохідність склала <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>.',
  100000165:'@we*** отримав 1 iPhone 15 за 1 USDT, дохідність складає <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>.',
  100000166:'Є ще багато цікавого…',
  100000167:'Невеликі кошти, великі повернення та постійний розвиток ігрового процесу роблять кожну участь сповненою сюрпризів!',
  100000168:'Спот, контракт, управління капіталом…',
  100000169:'Лист довгий, давайте продовжимо читати',
  100000170:'Сумарна емісія токенів понад <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span>, SuperEx і надалі намагатиметься створювати більше можливостей для користувачів.',
  100000171:'Річний огляд гаманця Акаунт накоплений',
  100000172:'Огляд гаманця Обліковий запис Річна прибуток і збиток <em class="normal bold {classNum}">{num}</em>',
  100000173:'Ви випереджаєте <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> користувачів. Ваша мудрість в інвестиційних стратегіях вражає.',
  100000174:'2025-SuperEx',
  100000175:'Шлях до багатства',
  100000176:'Коли ви будете готові',
  100000177:'Привіт! Я новий друг SuperEx.',
  100000178:'Приєднуйтеся до SuperEx та відкрийте для себе безмежні можливості. Зареєструйтеся та отримайте бонуси для нових користувачів.',
  100000179:'Користувач @vb*** бере участь у торгівлі на спот-основному ринку, накопичена дохідність $ATOM становить майже <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em>.',
  100000180:'Користувач @xi*** бере участь у торгівлі на спотовій основній платформі, кумулятивна прибутковість $PIPE близька до <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>.',
  100000181:'Користувач @09*** бере участь в спотовій торгівлі на основній платформі $ATH, накопичена прибутковість близько <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em>.',
  100000182:'Ми чекаємо, щоб свідчити про вашу першу угоду на WEB3 і розпочати захоплюючу главу!',
  100000183:'1USD Super Start、 1000+в акції, 150X вплив, 1000X запис',
  100000184:'Спробуйте різні високодохідні сектори!',
  100000185:'Злети та падіння тимчасові, але віра вічна.',
  100000186:'Пройшовши через волатильність, ви станете свідком справжньої цінності.',
  100000187:'Ваш звіт за 2024 рік ще не створено. Ласкаво просимо до нової торгової подорожі! Накопичуйте більше взаємодій, щоб розблокувати персоналізований підсумок наступного року!',
  100000188:'Щорічна історія криптовалюти за 2024 рік чекає на ваш перегляд! Переживіть яскраві моменти 2024 року разом із SuperEx, приходьте та поділіться своїми ексклюзивними моментами! ',
  100000189:'Щорічна історія криптовалюти за 2024 рік чекає на ваш перегляд!',
  100000190: 'Відкрийте додаток SuperEx, щоб переглянути “Річний звіт”.',
  100000191: '{year} рік {month} місяць {day} день (UTC)',
  100000192: 'Покупець',
  100000193: 'Код замовлення',
  100000194: 'Я',
  100000195: 'Список учасників',
  100000196: 'Цифрові валютні товари видано. Для отримання фізичних товарів зверніться в службу підтримки',
  100000197: 'Покупка успішна',
  100000198: '{name}успішно отримано',
  100000199: 'Купити',
  100000200: 'Все завантажено',
  100000201: 'Вітаємо {name} з виграшем {shop}!',
  100000202: 'Користувач {name} успішно приєднався до {shop}!'

}
export default uk


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/uk.js